import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import * as actions from './Actions';
import AgreementsList from './AgreementProductList';
import { handleError } from '../../shared/ErrorCatching';

class AgreementsPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
    }

    componentDidMount(): void {
        this.props.actions.listAgreementProducts().catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('photographer-agreement/page/title')}</h1>
                <AgreementsList agreementProducts={this.props.agreementProducts} />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        agreementProducts: state.photographerAgreement.list.sort((a: any, b: any) => {
            return a.name.localeCompare(b.name, 'sv');
        })
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            listAgreementProducts: () => dispatch(actions.list())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementsPage);
